/* Javascript - Sticky header */

window.onscroll = function () {
  toggleNavClass();
};

var navbar = document.getElementById("navbar");
var spacer = document.getElementById("fixed-spacer");
var logoWhite = document.getElementById("logo-white");
var logoWhiteLarge = document.getElementById("logo-white-lg");

$(document).ready(function () {
  toggleNavClass();
});

function toggleNavClass() {
  if (window.pageYOffset > 20) {
    navbar.classList.add("fixed-pos");

    spacer.classList.add("!h-16");
    spacer.classList.add("sm!h-20");

    logoWhiteLarge.classList.remove("large");
  } else {
    navbar.classList.remove("fixed-pos");

    spacer.classList.remove("!h-16");
    spacer.classList.remove("sm:!h-20");

    logoWhiteLarge.classList.add("large");
  }
}
